<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Федресурс</h5>
      <template v-if="messages?.length">
        <ul class="info-list mt-2">
          <li class="d-flex flex-row border-bottom align-items-end py-2">
            <span class="info-value">Сообщений</span><span class="info-bold">{{ messages.length }}</span>
          </li>
          <li class="border-bottom py-2">
            <span class="info-title">Последнее событие</span>
            <p class="mb-1">{{ latestMessage.message_type_name || latestMessage.message_type || 'Сообщение' }}</p>
            <span class="info-value">Дата: {{ formatDate(latestMessage.publish_date) }}</span>
          </li>
        </ul>
      </template>
      <template v-else><p>Нет данных</p></template>
      <button class="btn-primary btn-small d-block ms-auto mt-2" @click="emitChangeTab('tab-history')">
        Подробнее
      </button>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue';
  import moment from 'moment';

  export default {
    name: 'FedresursInfo',
    props: {
      messages: {
        type: Array,
        default: () => [],
      },
    },
    setup(props, { emit }) {
      const latestMessage = computed(() => {
        if (!props.messages?.length) {
          return {};
        }

        return [...props.messages].sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date))[0];
      });

      const formatDate = (date) => {
        return date ? moment(date).format('DD.MM.YYYY') : 'Нет данных';
      };

      const emitChangeTab = (newTab) => {
        emit('change-tab', newTab);
      };

      return {
        latestMessage,
        formatDate,
        emitChangeTab,
      };
    },
  };
</script>
